export default __webpack_public_path__ + "static/media/certificate_napa_fr.edae8ce7.svg";